<template>
    <crud-update
        :open="open"
        :loading="loading"
        title="Editar Vendedor"
        :errorMessage="errorMessage"
        @update="update"
        @close="$emit('close')"
    >
        <vendedor-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>
import VendedorProvider from "../../../providers/VendedorProvider";
import { CrudUpdate } from "@dracul/common-frontend";
import ClientError from "@/errors/ClientError";
import VendedorForm from "../VendedorForm/VendedorForm.vue";

export default {
    name: "VendedorUpdate",
    components: { VendedorForm, CrudUpdate },
    props: {
        open: { type: Boolean, default: true },
        item: { type: Object, required: true },
    },
    data() {
        return {
            errorMessage: "",
            inputErrors: {},
            loading: false,
            form: {
                id: this.item.id,
                nombre: this.item.nombre,
                apellido: this.item.apellido,
                email: this.item.email,
                telefono: this.item.telefono,
                comision: this.item.comision != null ? this.item.comision : 0,
                activo: this.item.activo !== undefined ? this.item.activo : true,
            },
        };
    },
    methods: {
        update() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                const { id, ...input } = this.form;
                VendedorProvider.updateVendedor(id, input)
                    .then((r) => {
                        if (r) {
                            this.$emit("itemUpdated", r.data.vendedorUpdate);
                            this.$emit("close");
                        }
                    })
                    .catch((error) => {
                        let clientError = new ClientError(error);
                        this.inputErrors = clientError.inputErrors;
                        this.errorMessage = clientError.i18nMessage;
                    })
                    .finally(() => (this.loading = false));
            }
        },
    },
};
</script>
